import { useLocation } from '../api/apiQueries'
import { useLocationId } from './useLocationId'

/**
 * The location identified by the `:sid` segment of the current route, or undefined while it loads or when the route has none.
 * Pass it to the `*ForLocation` date formatters, which fall back to the browser time zone when no location is available.
 */
export function useRouteLocation() {
  const { locationId } = useLocationId()
  return useLocation(locationId).data
}
